// Package imports
import { createSlice } from "@reduxjs/toolkit";

// Custom imports
import { findIndex, remove } from "lodash";

// Initial State
const initialState = {
  selectedTasks: [],
  assignmentName: "",
  description: "",
  commences: null,
  expiries: null,
  mode: "create",
  assignmentId: null,
  product: null,
  duration: 0,
  durationStartTimeStamp: 0,
  durationFlag: false,
  StepIndicatorPosition: 0,
  eexam:false,
  eexamTime: '15',
  defaults: {
    defaults: {
      noofattempts: '3',
      showattemptpopup: true,
      showpreviousbutton: false,
      shufflefunctionality: true,
      showgotofunctionality: false,
      showresetfunctionality: true,
      showanswerfunctionality: true,
    },
  },
  selectedClasses: [],
  selectedLearners: []
};

// Redux Slice for Assign
const assignmentSlice = createSlice({
  name: "assignment",
  initialState,
  reducers: {
    resetState(state, { payload }) {
      return initialState;
    },
    addTask(state, { payload }) {
      return {
        ...state,
        selectedTasks: [...state.selectedTasks, payload],
      };
    },
    removeTask(state, { payload }) {
      let tasksArray = [...state.selectedTasks];
      let pos = findIndex(tasksArray, { id: payload });
      tasksArray.splice(pos, 1);
      return {
        ...state,
        selectedTasks: tasksArray,
      };
    },
    setAllSelectedTasks(state, { payload }) {
      return {
        ...state,
        selectedTasks: payload,
      };
    },
    setAssignmentName(state, { payload }) {
      return {
        ...state,
        assignmentName: payload,
      };
    },
    setDescription(state, { payload }) {
      return {
        ...state,
        description: payload,
      };
    },
    setCommences(state, { payload }) {
      return {
        ...state,
        commences: payload,
      };
    },
    setExpiries(state, { payload }) {
      return {
        ...state,
        expiries: payload,
      };
    },
    setMode(state, { payload }) {
      return {
        ...state,
        mode: payload,
      };
    },
    setAssignmentId(state, { payload }) {
      return {
        ...state,
        assignmentId: payload,
      };
    },
    setProduct(state, { payload }) {
      return {
        ...state,
        product: payload,
      };
    },
    setEexam(state, { payload }) {
      return {
        ...state,
        eexam: payload,
      };
    },
    setEexamTime(state, { payload }) {
      if(isNaN(payload)){
        payload = '15'
      }
      return {
        ...state,
        eexamTime: payload,
      };
    },
    setDefaultsAttempts(state, { payload }) {
      if(isNaN(payload)){
        payload = '3'
      }
      return {
        ...state,
        defaults: {
          defaults:{
            ...state.defaults.defaults,
            noofattempts: payload
          }
        },
      };
    },
    setDefaultsShowAnswer(state, { payload }) {
      return {
        ...state,
        defaults: {
          defaults:{
            ...state.defaults.defaults,
            showanswerfunctionality: payload
          }
        },
      };
    },
    setDefaultsShuffleOptions(state, { payload }) {
      console.log("@@@@@",state.defaults);
      return {
        ...state,
        defaults: {
          defaults:{
            ...state.defaults.defaults,
            shufflefunctionality: payload
          }
        },
      };
    },
    setStepIndicatorPosition(state, { payload }) {
      return {
        ...state,
        StepIndicatorPosition: payload,
      };
    },
    addClass(state, { payload }) {
      return {
        ...state,
        selectedClasses: [...state.selectedClasses, payload],
      };
    },
    removeClass(state, { payload }) {
      let classesArray = [...state.selectedClasses];
      let pos = findIndex(classesArray, { id: payload });
      let selectedLearnersAfterClassRemove = state.selectedLearners.filter((obj) => {
        return obj.belongs_to != payload
      });
      classesArray.splice(pos, 1);
      return {
        ...state,
        selectedLearners: selectedLearnersAfterClassRemove,
        selectedClasses: classesArray,
      };
    },
    setAllSelectedClass(state, { payload }) {
      return {
        ...state,
        selectedClasses: payload,
      };
    },
    addLearner(state, { payload }) {
      return {
        ...state,
        selectedLearners: [...state.selectedLearners, payload],
      };
    },
    removeLearner(state, { payload }) {
      let learnerArray = [...state.selectedLearners];
      let pos = findIndex(learnerArray, { id: payload });
      learnerArray.splice(pos, 1);
      return {
        ...state,
        selectedLearners: learnerArray,
      };
    },
    setAllSelectedLearners(state, { payload }) {
      return {
        ...state,
        selectedLearners: payload,
      };
    },
    startDuration(state, { payload }) {
      if (state.durationFlag) {
        let startdateObj = new Date();
        return {
          ...state,
          durationStartTimeStamp: startdateObj.getTime(),
        };
      }
    },
    stopDuration(state, { payload }) {
      if (state.durationFlag) {
        let enddateObj = new Date();
        let endtimestamp = enddateObj.getTime();
        let duration = 0;
        if (state.durationStartTimeStamp != 0) {
          duration =
            +endtimestamp -
            +state.durationStartTimeStamp +
            Number(state.duration);
        }

        return {
          ...state,
          durationStartTimeStamp: 0,
          duration: duration,
        };
      }
    },
    setDurationFlag(state, { payload }) {
      return {
        ...state,
        durationFlag: payload,
      };
    },
  },
});

export const assignmentSliceActions = assignmentSlice.actions;

export default assignmentSlice;
